module.exports = __webpack_public_path__ + "static/media/icon-update.05796d98.svg";